<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <!-- Tabs -->
  <ul class="nav nav-tabs d-flex" role="tablist">
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='approved'" (click)="setActiveTab('approved')"
        type="button">
        Approved Payments
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='pending'" (click)="setActiveTab('pending')"
        type="button">
        Pending Approval
        <span class="badge bg-danger ms-1">{{ pendingPayslipTotalCount }}</span>
      </button>
    </li>
    <li class="nav-item flex-fill text-center" role="presentation">
      <button class="nav-link w-100" [class.active]="activeTab==='rejected'" (click)="setActiveTab('rejected')"
        type="button">
        Rejected Payments
        <!-- <span class="badge bg-danger ms-1">{{this.filteredRejectedCompanies.length}}</span> -->
      </button>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content mt-3">
    <!-- Approved Payments Tab -->
    <div class="tab-pane fade" [class.show]="activeTab==='approved'" [class.active]="activeTab==='approved'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <!-- Header -->
          <div class="row mb-2">
            <div class="col-md-12 col-sm-12">
              <div class="p-3 rounded-3 border bg-light h-100">
                <div class="small text-muted d-flex align-items-center gap-2">
                  <i class="bi bi-check-circle"></i>
                  Approved Payments
                </div>
                <div class="text-muted small mt-1">
                  Select a company to view approved payments.
                </div>
              </div>
            </div>
          </div>

          <!-- Search -->
          <div class="row g-3 align-items-end mb-3 mt-2">
            <div class="col-md-12">
              <label class="label-text">Search Companies</label>
              <div class="position-relative">
                <input type="text" class="form-control user-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="approvedCompanySearchText"
                  (input)="performApprovedCompanySearch()" />
                <span class="search-icon" (click)="performApprovedCompanySearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isApprovedCompaniesLoading" class="text-muted">Loading companies...</div>
          <!-- Empty / Error State -->
          <div *ngIf="!isApprovedCompaniesLoading && (approvedCompaniesError || filteredApprovedCompanies.length === 0)"
            class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">
              {{ approvedCompaniesError
              ? approvedCompaniesError
              : 'No Companies with Approved Payments were Found.' }}
            </p>
          </div>

          <!-- Companies table with expandable rows -->
          <div *ngIf="filteredApprovedCompanies.length > 0" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start" style="width: 48px;"></th>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-start">Company ID</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let company of pagedApprovedCompanies">
                  <!-- Company row -->
                  <tr class="clickable-row" role="button" tabindex="0" (click)="toggleApprovedCompanyExpand(company)">
                    <td class="text-start">
                      <button class="btn p-0" style="background: none; border: none;"
                        (click)="$event.stopPropagation(); toggleApprovedCompanyExpand(company)"
                        [attr.aria-expanded]="isApprovedCompanyExpanded(company.companyId)"
                        [attr.aria-controls]="'approved-payments-row-' + company.companyId">
                        <i class="bi"
                          [ngClass]="isApprovedCompanyExpanded(company.companyId) ? 'bi-chevron-down' : 'bi-chevron-right'"
                          style="font-size: 1.05rem; color: var(--primary-color);"></i>
                      </button>
                    </td>
                    <td class="table-data-text text-start">{{ company.companyName }}</td>
                    <td class="table-data-text text-start">{{ company.companyId }}</td>
                  </tr>

                  <!-- Expanded row: payments -->
                  <tr *ngIf="isApprovedCompanyExpanded(company.companyId)"
                    [attr.id]="'approved-payments-row-' + company.companyId">
                    <td></td>
                    <td colspan="2">
                      <div class="p-3 rounded-3 border bg-light">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <div class="small text-muted d-flex align-items-center gap-2">
                            <i class="bi bi-receipt"></i>
                            Payments
                          </div>
                          <div class="small">
                            <span *ngIf="isApprovedPaymentsLoadingMap[company.companyId]"
                              class="text-muted">Loading…</span>
                            <span *ngIf="approvedPaymentsErrorMap[company.companyId]" class="text-danger">{{
                              approvedPaymentsErrorMap[company.companyId] }}</span>
                            <span
                              *ngIf="!isApprovedPaymentsLoadingMap[company.companyId] && !approvedPaymentsErrorMap[company.companyId] && (approvedPaymentsByCompany.get(company.companyId)?.length ?? 0) === 0"
                              class="text-muted">No payments found.</span>
                          </div>
                        </div>

                        <div *ngIf="(approvedPaymentsByCompany.get(company.companyId)?.length ?? 0) > 0"
                          class="table-responsive-wrapper">
                          <table class="table table-bordered mb-0">
                            <thead>
                              <tr>
                                <th class="table-title text-start">Salary Payment ID</th>
                                <th class="table-title text-start">Invoice Type</th>
                                <th class="table-title text-end">Total Amount (LKR)</th>
                                <th class="table-title text-end">Previously Paid (LKR)</th>
                                <th class="table-title text-end">Instalment Payment Settled (LKR)</th>
                                <th class="table-title text-end">Total Paid Amount (LKR)</th>
                                <th class="table-title text-end">Balance (LKR)</th>
                                <th class="table-title text-center" style="width: 48px;"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let payment of approvedPaymentsByCompany.get(company.companyId)">
                                <td class="table-data-text text-start">{{ payment.paySlipId }}</td>
                                <td class="table-data-text text-start">{{ payment.invoiceType || '-' }}</td>
                                <td class="table-data-text text-end">{{ (payment.totalAmount ?? 0) | number:'1.2-2' }}
                                </td>
                                <td class="table-data-text text-end">{{ (payment.previouslyPaid ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.paidAmount ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.paidAmount ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.balance ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-center">
                                  <button class="btn p-0" style="background: none; border: none;"
                                    (click)="$event.stopPropagation(); openPaymentDetails(company, payment)"
                                    [attr.data-bs-toggle]="'offcanvas'"
                                    [attr.data-bs-target]="'#paymentDetailsOffcanvas'">
                                    <i class="bi bi-arrow-right"
                                      style="font-size: 1.1rem; color: var(--primary-color);"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <app-paginator [dataSource]="filteredApprovedCompanies" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onApprovedCompaniesPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>

    <!-- Pending Approval Tab -->
    <div class="tab-pane fade" [class.show]="activeTab==='pending'" [class.active]="activeTab==='pending'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <!-- Header -->
          <div class="row mb-2">
            <div class="col-md-12 col-sm-12">
              <div class="p-3 rounded-3 border bg-light h-100">
                <div class="small text-muted d-flex align-items-center gap-2">
                  <i class="bi bi-clock-history"></i>
                  Pending Approval
                </div>
                <div class="text-muted small mt-1">
                  Select a company to view pending payments awaiting approval.
                </div>
              </div>
            </div>
          </div>

          <!-- Search -->
          <div class="row g-3 align-items-end mb-3 mt-2">
            <div class="col-md-12">
              <label class="label-text">Search Companies</label>
              <div class="position-relative">
                <input type="text" class="form-control user-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="pendingCompanySearchText"
                  (input)="performPendingCompanySearch()" />
                <span class="search-icon" (click)="performPendingCompanySearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isPendingCompaniesLoading" class="text-muted">Loading companies...</div>
          <!-- <div *ngIf="pendingCompaniesError" class="text-danger">{{ pendingCompaniesError }}</div> -->
          <!-- Empty State -->
          <div *ngIf="!isPendingCompaniesLoading && (pendingCompaniesError || filteredPendingCompanies.length === 0)"
            class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">
              {{ pendingCompaniesError
              ? pendingCompaniesError
              : 'No Companies with Pending Payments were Found.' }}
            </p>
          </div>

          <!-- Companies table with expandable rows -->
          <div *ngIf="filteredPendingCompanies.length > 0" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start" style="width: 48px;"></th>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-start">Company ID</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let company of pagedPendingCompanies">
                  <!-- Company row -->
                  <tr class="clickable-row" role="button" tabindex="0" (click)="togglePendingCompanyExpand(company)">
                    <td class="text-start">
                      <button class="btn p-0" style="background: none; border: none;"
                        (click)="$event.stopPropagation(); togglePendingCompanyExpand(company)"
                        [attr.aria-expanded]="isPendingCompanyExpanded(company.companyId)"
                        [attr.aria-controls]="'payments-row-' + company.companyId">
                        <i class="bi"
                          [ngClass]="isPendingCompanyExpanded(company.companyId) ? 'bi-chevron-down' : 'bi-chevron-right'"
                          style="font-size: 1.05rem; color: var(--primary-color);"></i>
                      </button>
                    </td>
                    <td class="table-data-text text-start">{{ company.companyName }}</td>
                    <td class="table-data-text text-start">{{ company.companyId }}</td>
                  </tr>

                  <!-- Expanded row: payments -->
                  <tr *ngIf="isPendingCompanyExpanded(company.companyId)"
                    [attr.id]="'payments-row-' + company.companyId">
                    <td></td>
                    <td colspan="2">
                      <div class="p-3 rounded-3 border bg-light">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <div class="small text-muted d-flex align-items-center gap-2">
                            <i class="bi bi-receipt"></i>
                            Payments
                          </div>
                          <div class="small">
                            <span *ngIf="isPaymentsLoadingMap[company.companyId]" class="text-muted">Loading…</span>
                            <span *ngIf="paymentsErrorMap[company.companyId]" class="text-danger">{{
                              paymentsErrorMap[company.companyId] }}</span>
                            <span
                              *ngIf="!isPaymentsLoadingMap[company.companyId] && !paymentsErrorMap[company.companyId] && (paymentsByCompany.get(company.companyId)?.length ?? 0) === 0"
                              class="text-muted">No payments found.</span>
                          </div>
                        </div>

                        <div *ngIf="(paymentsByCompany.get(company.companyId)?.length ?? 0) > 0"
                          class="table-responsive-wrapper">
                          <table class="table table-bordered mb-0">
                            <thead>
                              <tr>
                                <th class="table-title text-start">Salary Payment ID</th>
                                <th class="table-title text-start">Invoice Type</th>
                                <th class="table-title text-end">Total Amount (LKR)</th>
                                <th class="table-title text-end">Previously Paid (LKR)</th>
                                <th class="table-title text-end">Instalment Payment Settled (LKR)</th>
                                <th class="table-title text-end">Total Paid Amount (LKR)</th>
                                <th class="table-title text-end">Balance (LKR)</th>
                                <th class="table-title text-center" style="width: 48px;"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let payment of paymentsByCompany.get(company.companyId)">
                                <td class="table-data-text text-start">{{ payment.paySlipId }}</td>
                                <td class="table-data-text text-start">{{ payment.invoiceType || '-' }}</td>
                                <td class="table-data-text text-end">{{ (payment.totalAmount ?? 0) | number:'1.2-2' }}
                                </td>
                                <td class="table-data-text text-end">{{ (payment.previouslyPaid ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ getAmountSettled(payment) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.paidAmount ?? 0) | number:'1.2-2' }}
                                </td>
                                <td class="table-data-text text-end">{{ (payment.balance ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-center">
                                  <button class="btn p-0" style="background: none; border: none;"
                                    (click)="$event.stopPropagation(); openPaymentDetails(company, payment)"
                                    [attr.data-bs-toggle]="'offcanvas'"
                                    [attr.data-bs-target]="'#paymentDetailsOffcanvas'">
                                    <i class="bi bi-arrow-right"
                                      style="font-size: 1.1rem; color: var(--primary-color);"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <app-paginator [dataSource]="filteredPendingCompanies" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onPendingCompaniesPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>

    <!-- Rejected Payments Tab -->
    <div class="tab-pane fade" [class.show]="activeTab==='rejected'" [class.active]="activeTab==='rejected'">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <!-- Header -->
          <div class="row mb-2">
            <div class="col-md-12 col-sm-12">
              <div class="p-3 rounded-3 border bg-light h-100">
                <div class="small text-muted d-flex align-items-center gap-2">
                  <i class="bi bi-x-circle"></i>
                  Rejected Payments
                </div>
                <div class="text-muted small mt-1">
                  Select a company to view rejected payments.
                </div>
              </div>
            </div>
          </div>

          <!-- Search -->
          <div class="row g-3 align-items-end mb-3 mt-2">
            <div class="col-md-12">
              <label class="label-text">Search Companies</label>
              <div class="position-relative">
                <input type="text" class="form-control user-search-input shadow-none"
                  placeholder="Type here..." [(ngModel)]="rejectedCompanySearchText"
                  (input)="performRejectedCompanySearch()" />
                <span class="search-icon" (click)="performRejectedCompanySearch()">
                  <i class="bi bi-search"></i>
                </span>
              </div>
            </div>
          </div>

          <!-- States -->
          <div *ngIf="isRejectedCompaniesLoading" class="text-muted">Loading companies...</div>
          <!-- <div *ngIf="rejectedCompaniesError" class="text-danger">{{ rejectedCompaniesError }}</div> -->
          <!-- Empty State -->
          <div *ngIf="!isRejectedCompaniesLoading && (rejectedCompaniesError || filteredRejectedCompanies.length === 0)"
            class="text-center py-5">
            <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
            <p class="text-muted">
              {{ rejectedCompaniesError
              ? rejectedCompaniesError
              : 'No Companies with Rejected Payments were Found.' }}
            </p>
          </div>

          <!-- Companies table with expandable rows -->
          <div *ngIf="filteredRejectedCompanies.length > 0" class="table-responsive-wrapper">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="table-title text-start" style="width: 48px;"></th>
                  <th class="table-title text-start">Company Name</th>
                  <th class="table-title text-start">Company ID</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let company of pagedRejectedCompanies">
                  <!-- Company row -->
                  <tr class="clickable-row" role="button" tabindex="0" (click)="toggleRejectedCompanyExpand(company)">
                    <td class="text-start">
                      <button class="btn p-0" style="background: none; border: none;"
                        (click)="$event.stopPropagation(); toggleRejectedCompanyExpand(company)"
                        [attr.aria-expanded]="isRejectedCompanyExpanded(company.companyId)"
                        [attr.aria-controls]="'rejected-payments-row-' + company.companyId">
                        <i class="bi"
                          [ngClass]="isRejectedCompanyExpanded(company.companyId) ? 'bi-chevron-down' : 'bi-chevron-right'"
                          style="font-size: 1.05rem; color: var(--primary-color);"></i>
                      </button>
                    </td>
                    <td class="table-data-text text-start">{{ company.companyName }}</td>
                    <td class="table-data-text text-start">{{ company.companyId }}</td>
                  </tr>

                  <!-- Expanded row: payments -->
                  <tr *ngIf="isRejectedCompanyExpanded(company.companyId)"
                    [attr.id]="'rejected-payments-row-' + company.companyId">
                    <td></td>
                    <td colspan="2">
                      <div class="p-3 rounded-3 border bg-light">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <div class="small text-muted d-flex align-items-center gap-2">
                            <i class="bi bi-receipt"></i>
                            Payments
                          </div>
                          <div class="small">
                            <span *ngIf="isRejectedPaymentsLoadingMap[company.companyId]"
                              class="text-muted">Loading…</span>
                            <span *ngIf="rejectedPaymentsErrorMap[company.companyId]" class="text-danger">{{
                              rejectedPaymentsErrorMap[company.companyId] }}</span>
                            <span
                              *ngIf="!isRejectedPaymentsLoadingMap[company.companyId] && !rejectedPaymentsErrorMap[company.companyId] && (rejectedPaymentsByCompany.get(company.companyId)?.length ?? 0) === 0"
                              class="text-muted">No payments found.</span>
                          </div>
                        </div>

                        <div *ngIf="(rejectedPaymentsByCompany.get(company.companyId)?.length ?? 0) > 0"
                          class="table-responsive-wrapper">
                          <table class="table table-bordered mb-0">
                            <thead>
                              <tr>
                                <th class="table-title text-start">Salary Payment ID</th>
                                <th class="table-title text-start">Invoice Type</th>
                                <th class="table-title text-end">Total Amount (LKR)</th>
                                <th class="table-title text-end">Previously Paid (LKR)</th>
                                <th class="table-title text-end">Instalment Payment Settled (LKR)</th>
                                <th class="table-title text-end">Total Paid Amount (LKR)</th>
                                <th class="table-title text-end">Balance (LKR)</th>
                                <th class="table-title text-center" style="width: 48px;"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let payment of rejectedPaymentsByCompany.get(company.companyId)">
                                <td class="table-data-text text-start">{{ payment.paySlipId }}</td>
                                <td class="table-data-text text-start">{{ payment.invoiceType || '-' }}</td>
                                <td class="table-data-text text-end">{{ (payment.totalAmount ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.previouslyPaid ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.newlyPaid ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.paidAmount ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-end">{{ (payment.balance ?? 0) | number:'1.2-2' }}</td>
                                <td class="table-data-text text-center">
                                  <button class="btn p-0" style="background: none; border: none;"
                                    (click)="$event.stopPropagation(); openPaymentDetails(company, payment)"
                                    [attr.data-bs-toggle]="'offcanvas'"
                                    [attr.data-bs-target]="'#paymentDetailsOffcanvas'">
                                    <i class="bi bi-arrow-right"
                                      style="font-size: 1.1rem; color: var(--primary-color);"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <!-- Pagination toolbar -->
            <app-paginator [dataSource]="filteredRejectedCompanies" [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 50]"
              (pageChange)="onRejectedCompaniesPageChange($event)">
            </app-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Offcanvas: Payment Details -->
<div class="offcanvas offcanvas-end w-70" tabindex="-1" id="paymentDetailsOffcanvas"
  aria-labelledby="paymentDetailsOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="paymentDetailsOffcanvasLabel">
            <i class="bi fs-5 bi-receipt"></i>
            Payment Details
            <span class="ms-2 text-muted small" *ngIf="selectedCompany">
              — {{ selectedCompany.companyName || 'Company' }}
            </span>
          </h5>
        </div>
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <div *ngIf="selectedPayment">
      <!-- Error State -->
      <div *ngIf="paymentDetailsError" class="alert alert-danger rounded-3 border-0">
        <i class="bi bi-exclamation-triangle me-2"></i>
        {{ paymentDetailsError }}
      </div>

      <!-- Payment Details -->
      <div *ngIf="!paymentDetailsError && paymentDetails">
        <!-- Payment Information -->
        <div class="card mb-4 border rounded-4 overflow-hidden">
          <div class="card-header bg-white border-bottom py-3 px-4 d-flex align-items-center gap-3">
            <div class="pd-icon-strip">
              <i class="bi bi-receipt-cutoff"></i>
            </div>
            <h6 class="mb-0 fw-bold text-dark">Payment Information</h6>
          </div>
          <div class="card-body p-0">
            <div class="pd-detail-grid">

              <!-- Invoice Type -->
              <div class="pd-detail-cell pd-detail-cell--left">
                <span class="pd-detail-label"><i class="bi bi-tag me-1"></i>Invoice Type</span>
                <span class="badge pd-invoice-type-badge">{{ paymentDetails.invoiceType || '-' }}</span>
              </div>

              <!-- Salary Cycle -->
              <div class="pd-detail-cell">
                <span class="pd-detail-label"><i class="bi bi-arrow-repeat me-1"></i>Salary Cycle</span>
                <span class="fw-semibold text-dark">{{ paymentDetails.salaryCycle || '-' }}</span>
              </div>

              <!-- Reference Number — full width -->
              <div class="pd-detail-cell pd-detail-cell--full">
                <span class="pd-detail-label"><i class="bi bi-hash me-1"></i>Reference Number</span>
                <code class="pd-ref-chip">{{ paymentDetails.referenceNumber || '-' }}</code>
              </div>

              <!-- Issue Date -->
              <div class="pd-detail-cell pd-detail-cell--left">
                <span class="pd-detail-label"><i class="bi bi-calendar-event me-1"></i>Issue Date</span>
                <span class="pd-date-chip">
                  <i class="bi bi-calendar3"></i>
                  {{ paymentDetails.issueDate | date: 'yyyy-MM-dd' }}
                </span>
              </div>

              <!-- Due Date -->
              <div class="pd-detail-cell">
                <span class="pd-detail-label"><i class="bi bi-calendar-x me-1"></i>Due Date</span>
                <span class="pd-date-chip pd-date-chip--due">
                  <i class="bi bi-calendar3"></i>
                  {{ paymentDetails.dueDate | date: 'yyyy-MM-dd' }}
                </span>
              </div>

              <!-- Actual Payment Date — full width -->
              <div class="pd-detail-cell pd-detail-cell--full">
                <label for="actualPaymentDate" class="pd-detail-label">
                  <i class="bi bi-calendar-check me-1"></i>Actual Payment Date
                  <span class="text-danger ms-1" *ngIf="activeTab === 'pending'">*</span>
                </label>
                <input type="date" class="form-control pd-date-input" id="actualPaymentDate"
                  [(ngModel)]="actualPaymentDate"
                  [max]="todayDateString"
                  [disabled]="activeTab !== 'pending'" />
              </div>

            </div>

            @if(paymentDetails.isRejected){
            <div class="px-4 pb-4">
              <div class="bg-danger bg-opacity-10 border border-danger rounded-3 p-3">
                <small class="text-danger fw-bold d-block mb-1">Rejection Reason</small>
                <p class="mb-0 text-danger">{{ paymentDetails.rejectionReason || 'No reason provided' }}</p>
              </div>
            </div>
            }

          </div>
        </div>

        <!-- Late Fee Breakdown (only when lateFee is present) -->
        <div class="card mb-4 border rounded-4 overflow-hidden" *ngIf="paymentDetails.lateFee">
          <div class="card-header bg-white border-bottom py-3 px-4 d-flex align-items-center gap-3">
            <div class="pd-icon-strip">
              <i class="bi bi-exclamation-circle"></i>
            </div>
            <h6 class="mb-0 fw-bold text-dark">Amount Breakdown</h6>
          </div>
          <div class="card-body p-4 bg-white">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="text-center p-3 bg-light rounded-3">
                  <small class="text-secondary d-block mb-2">Invoice Amount</small>
                  <h5 class="mb-0 fw-bold text-dark">{{ ((paymentDetails.totalAmount ?? 0) - (paymentDetails.lateFee)) | number:'1.2-2' }}</h5>
                  <small class="text-muted">LKR</small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="text-center p-3 bg-danger bg-opacity-10 rounded-3">
                  <small class="text-danger d-block mb-2">Late Fee</small>
                  <h5 class="mb-0 fw-bold text-danger">{{ (paymentDetails.lateFee) | number:'1.2-2' }}</h5>
                  <small class="text-danger">LKR</small>
                  <!-- <div class="mt-1" *ngIf="paymentDetails.lateFeeAddInvoiceNumber">
                    <code class="pd-ref-chip" style="font-size: 0.7rem;">{{ paymentDetails.lateFeeAddInvoiceNumber }}</code>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Amount Information -->
        <div class="card mb-4 border rounded-4 overflow-hidden">
          <div class="card-header bg-white border-bottom py-3 px-4">
            <h6 class="mb-0 fw-bold text-dark">Amount Information</h6>
          </div>
          <div class="card-body p-4 bg-white">
            <div class="row g-3">
              <div class="col-md-4">
                <div class="text-center p-3 bg-light rounded-3">
                  <small class="text-secondary d-block mb-2">Total Amount</small>
                  <h5 class="mb-0 fw-bold text-dark">{{ (paymentDetails.totalAmount ?? 0) | number:'1.2-2' }}</h5>
                  <small class="text-muted">LKR</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="text-center p-3 bg-success bg-opacity-10 rounded-3">
                  <small class="text-success d-block mb-2">Paid Amount</small>
                  <h5 class="mb-0 fw-bold text-success">{{ (paymentDetails.paidAmount ?? 0) | number:'1.2-2' }}</h5>
                  <small class="text-success">LKR</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="text-center p-3 bg-warning bg-opacity-10 rounded-3">
                  <small class="text-warning d-block mb-2">Balance Due</small>
                  <h5 class="mb-0 fw-bold text-warning">{{ (paymentDetails.balance ?? 0) | number:'1.2-2' }}</h5>
                  <small class="text-warning">LKR</small>
                </div>
              </div>

              <!-- Payment Breakdown — EWW_TOTAL invoices only; not applicable for rollover payments -->
              <div class="col-12"
                *ngIf="activeTab === 'pending' && (!isRolloverInvoice && ((paymentDetails.previouslyPaid ?? 0) > 0 || (paymentDetails.newlyPaid ?? 0) > 0))">
                <div class="p-3 bg-light border rounded-3">
                  <small class="text-secondary fw-semibold d-block mb-2">
                    <i class="bi bi-layers me-1"></i>Payment Breakdown
                  </small>
                  <div class="row g-2">
                    <div class="col-md-6">
                      <div class="text-center p-2 bg-white border rounded-3">
                        <small class="text-secondary d-block mb-1">Previously Approved</small>
                        <span class="fw-bold text-dark">{{ (paymentDetails.previouslyPaid ?? 0) | number:'1.2-2' }}</span>
                        <small class="text-muted ms-1">LKR</small>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="text-center p-2 rounded-3"
                        [ngClass]="(paymentDetails.newlyPaid ?? 0) > 0 ? 'bg-warning bg-opacity-10 border border-warning' : 'bg-white border'">
                        <small [ngClass]="(paymentDetails.newlyPaid ?? 0) > 0 ? 'text-warning' : 'text-secondary'"
                          class="d-block mb-1">Newly Submitted</small>
                        <span class="fw-bold"
                          [ngClass]="(paymentDetails.newlyPaid ?? 0) > 0 ? 'text-warning' : 'text-dark'">
                          {{ (paymentDetails.newlyPaid ?? 0) | number:'1.2-2' }}
                        </span>
                        <small [ngClass]="(paymentDetails.newlyPaid ?? 0) > 0 ? 'text-warning' : 'text-muted'"
                          class="ms-1">LKR</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Payment Ledger Selection — non-rollover, pending tab only -->
        <div class="card mb-4 border rounded-4 overflow-hidden" *ngIf="activeTab === 'pending' && !isRolloverInvoice">
          <div class="card-header bg-white border-bottom py-3 px-4 d-flex align-items-center gap-3">
            <div class="pd-icon-strip">
              <i class="bi bi-list-check"></i>
            </div>
            <div class="d-flex flex-column">
              <h6 class="mb-0 fw-bold text-dark">Select Payments to Approve</h6>
              <small class="text-muted" style="font-size: 11px;">Check the rows you wish to include in this approval</small>
            </div>
            <span class="ms-auto ledger-selection-badge" *ngIf="selectedPaymentIds.size > 0">
              <i class="bi bi-check2-circle me-1"></i>{{ selectedPaymentIds.size }} selected
            </span>
          </div>
        
          <div class="card-body p-0">
            <!-- Loading -->
            <div *ngIf="isPaymentsLoading" class="ledger-state-box">
              <span class="spinner-border spinner-border-sm text-success me-2" role="status"></span>
              <span class="text-muted small">Loading payments…</span>
            </div>
            <!-- Error -->
            <div *ngIf="!isPaymentsLoading && paymentsLoadError" class="px-4 py-3">
              <div class="alert alert-warning mb-0 small">{{ paymentsLoadError }}</div>
            </div>
            <!-- Empty -->
            <div *ngIf="!isPaymentsLoading && !paymentsLoadError && invoicePayments.length === 0" class="ledger-state-box">
              <i class="bi bi-inbox text-muted mb-1" style="font-size: 1.4rem;"></i>
              <span class="text-muted small">No pending payments found.</span>
            </div>
            <!-- Table -->
            <div *ngIf="!isPaymentsLoading && !paymentsLoadError && invoicePayments.length > 0" class="ledger-table-wrapper">
              <table class="table ledger-table mb-0">
                <thead>
                  <tr>
                    <th class="ledger-th" style="width: 44px;">
                      <input type="checkbox" class="ledger-checkbox" [checked]="allPaymentsSelected"
                        (change)="toggleAllPayments()" />
                    </th>
                    <th class="ledger-th">#</th>
                    <th class="ledger-th">Amount Paid (LKR)</th>
                    <th class="ledger-th">Balance Before</th>
                    <th class="ledger-th">Status</th>
                    <th class="ledger-th">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of invoicePayments" class="ledger-row"
                    [class.ledger-row--selected]="selectedPaymentIds.has(p.paymentId)"
                    (click)="togglePaymentSelection(p.paymentId)">
                    <td class="ledger-td" (click)="$event.stopPropagation()">
                      <input type="checkbox" class="ledger-checkbox" [checked]="selectedPaymentIds.has(p.paymentId)"
                        (change)="togglePaymentSelection(p.paymentId)" />
                    </td>
                    <td class="ledger-td ledger-num">{{ p.paymentNumber }}</td>
                    <td class="ledger-td ledger-amount">{{ p.paymentAmount | number:'1.2-2' }}</td>
                    <td class="ledger-td ledger-amount text-muted">{{ p.balanceBefore | number:'1.2-2' }}</td>
                    <td class="ledger-td">
                      <span class="ledger-status-badge">{{ p.status }}</span>
                    </td>
                    <td class="ledger-td ledger-date">{{ p.createdDateUtc | date:'yyyy-MM-dd' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Payment Slip -->
        <div class="card mb-4 border rounded-4 overflow-hidden" *ngIf="paymentDetails.paymentSlip">
          <div class="card-header bg-white border-bottom py-3 px-4">
            <h6 class="mb-0 fw-bold text-dark">Payment Slip</h6>
          </div>
          <div class="card-body p-4 bg-white text-center">
            <img [src]="paymentDetails.paymentSlip" alt="Payment Slip" class="img-fluid rounded-3 border"
              style="max-height: 500px; cursor: pointer;" (click)="openImageInNewTab(paymentDetails.paymentSlip, paymentDetails.invoiceType, paymentDetails.salaryCycle, paymentDetails.issueDate)"
              onerror="this.style.display='none'">
          </div>
        </div>

        <!-- Action Buttons - Only show for pending tab -->
        <div class="approval-actions-bar" *ngIf="activeTab === 'pending' && authService.canReview('manageCixorPayments.cixorPayments')">
          <button type="button" class="btn approval-btn-reject"
            [disabled]="isRejecting || isApproving"
            (click)="openRejectionModal()">
            <i class="bi bi-x-circle"></i>
            Reject
          </button>
          <button type="button" class="btn approval-btn-approve"
            [disabled]="isApproving || isRejecting || !actualPaymentDate || (!isRolloverInvoice && invoicePayments.length > 0 && selectedPaymentIds.size === 0)"
            (click)="approvePayment()">
            <ng-container *ngIf="!isApproving">
              <i class="bi bi-check-circle"></i>
              Approve
            </ng-container>
            <ng-container *ngIf="isApproving">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Approving...
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Rejection Reason Modal -->
<div class="modal fade" id="rejectionModal" tabindex="-1" aria-labelledby="rejectionModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="rejectionModalLabel">
          <i class="bi bi-exclamation-triangle text-danger me-2"></i>
          Reject Payment
        </h5>
        <button type="button" class="btn-close" (click)="closeRejectionModal()" [disabled]="isRejecting"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="rejectionReason" class="form-label label-text">
            Rejection Reason <span class="text-danger">*</span>
          </label>
          <textarea class="form-control" id="rejectionReason" rows="4" [(ngModel)]="rejectionReason"
            [disabled]="isRejecting" placeholder="Please provide a reason for rejecting this payment..."
            [class.is-invalid]="rejectionReasonError"></textarea>
          <div class="invalid-feedback d-block" *ngIf="rejectionReasonError">
            {{ rejectionReasonError }}
          </div>
          <div class="form-text">
            This field is required. Please provide a clear reason for rejection.
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeRejectionModal()" [disabled]="isRejecting">
          Cancel
        </button>
        <button type="button" class="btn btn-danger" (click)="rejectPayment()" [disabled]="isRejecting">
          <span *ngIf="!isRejecting">
            <i class="bi bi-x-circle me-1"></i>
            Reject Payment
          </span>
          <span *ngIf="isRejecting">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Rejecting...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>